import FooterHolder from "./FooterHolder";

const Footer = () => {
    return (
        <FooterHolder>
            Todos los derechos reservados, RODAVI S.A 2022
        </FooterHolder>
    )
}

export default Footer;